import { css } from "@compiled/react";
import { useIntl } from "react-intl";

// TODO: uncomment when media query tokens works
// import { media } from "@atlaskit/primitives/responsive";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";
import TabsCustom from "@/patterns/wpl/tabs-custom/src";

import { IndividualTabPropsCustom } from "../../tab-group/src";

const tabStyles = css({
    ".tab-group": {
        'div[role="tablist"]': {
            display: "block"
        },
        "div.select-container": {
            display: "none"
        },
        "div.tab-group-inner": {
            "gap": 0,
            "width": "100%",
            "padding": 0,

            // TODO: replace with [media.above.md] when media query tokens works
            "@media (min-width: 768px)": {
                padding: "0 15% 0 15%"
            },

            /* eslint-disable-next-line @atlaskit/design-system/no-physical-properties */
            "borderBottom": "1px solid #c1c7d0",
            "button": {
                "display": "flex",
                "justifyContent": "center",
                "alignItems": "center",
                "color": "#5e6c84",
                "borderRadius": 0,
                "position": "relative",
                "insetBlockStart": 1,
                "width": "50%",
                "fontSize": ".875rem",
                "lineHeight": 1,
                "padding": "20px",
                "border": "1px solid #c1c7d0",
                "height": "70px",
                "&:focus, &[aria-selected=true]": {
                    backgroundColor: "#fff",
                    outline: "none",
                    borderBlockEnd: "1px solid #fff",
                    zIndex: 2
                },
                "&:focus-visible": {
                    outline: "auto 1px #0052cc"
                },
                "&[aria-selected=false]:hover": {
                    opacity: ".7"
                },
                "&:first-of-type": {
                    borderRadius: "6px 0 0 0"
                },
                "&:last-of-type": {
                    borderRadius: "0 6px 0 0",
                    borderInlineStart: "none"
                },
                "svg": {
                    marginInlineEnd: "10px"
                }
            }
        },
        ".row-layout": {
            maxWidth: "1440px",
            width: "100%",
            margin: "0 auto 0 auto",
            padding: 0
        }
    }
});

export interface PricingTabsProps {
    cloudComponent: JSX.Element;
    dataCenterComponent: JSX.Element;
    dataProductKey: ProductKeyTypes;
}

export const DataCenterSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        width="36.8px"
        height="30px"
        viewBox="0 0 36.8 36"
        enableBackground="new 0 0 36.8 36;"
        xmlSpace="preserve"
    >
        <style type="text/css">
            {`
                .cloud.st0{display:none;opacity:0.4;}
                .cloud.st1{display:inline;}
                .cloud.st2{fill:#243858;}
                .cloud.st3{opacity:0.5;fill:#243858;enable-background:new    ;}
            `}
        </style>
        <g id="Layer_2_1_" className="cloud st0">
            <g id="Layer_2_2_" className="cloud st1">
                <g id="N700_1_">
                    <path
                        className="cloud st2"
                        d="M30.2,13.5c-0.6,0-1.2,0.1-1.7,0.3C27.4,8.2,22,4.6,16.5,5.7c-4.1,0.8-7.3,4-8.1,8.1     c-0.6-0.2-1.2-0.3-1.8-0.3c-3.5,0-6.3,2.8-6.3,6.3c0,3.5,2.8,6.3,6.3,6.3h1.2c0-0.2,0-0.3,0-0.5c0.1-2.9,2.6-5.1,5.5-5     c0.7,0,1.5,0.1,2.1,0.4c1-3,3.8-5,7-5c3.4-0.1,6.4,2.2,7.2,5.5h0.1c2,0,3.7,1.3,4.3,3.1c2.7-2.2,3-6.2,0.8-8.8     C33.7,14.3,32,13.5,30.2,13.5L30.2,13.5z"
                    />
                    <path
                        className="cloud st3"
                        d="M34.4,26c0-2.5-2-4.6-4.6-4.6h-0.1c-0.8-3.3-3.8-5.6-7.2-5.5c-3.2,0-6,2-7,5c-0.7-0.3-1.4-0.4-2.1-0.4     c-2.9-0.1-5.3,2.1-5.5,5s-2.6,5.1-5.5,5h27.4h0.3C32.5,30.4,34.4,28.4,34.4,26z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_1">
            <title>admin-server</title>
            <g id="Layer_2">
                <g id="N700">
                    <path
                        className="cloud st2"
                        d="M29.9,2.7H6.9c-1.1,0-2,0.9-2,2c0,0,0,0,0,0v6.1H32V4.8C32,3.7,31.1,2.7,29.9,2.7z M8.4,8.3     c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S9.3,8.3,8.4,8.3L8.4,8.3z M12.5,7.6     c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C13.2,7.2,12.9,7.6,12.5,7.6z M15,7.6     c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C15.8,7.2,15.4,7.6,15,7.6z M27.3,8.8h-0.8V4.8h0.8V8.8     z M29.3,8.8h-0.8V4.8h0.8V8.8z"
                    />
                    <path
                        className="cloud st2"
                        d="M4.9,13.1v9.8H32v-9.8H4.9z M8.4,19.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5     c0,0,0,0,0,0C9.9,18.8,9.3,19.5,8.4,19.5z M12.5,18.8c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8l0,0     C13.2,18.4,12.9,18.8,12.5,18.8z M15,18.8c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0     C15.8,18.4,15.4,18.8,15,18.8z M27.3,20h-0.8V16h0.8V20z M29.3,20h-0.8V16h0.8V20z"
                    />
                    <path
                        className="cloud st2"
                        d="M4.9,25.1v6.1c0,1.1,0.9,2,2,2c0,0,0,0,0,0h23.1c1.1,0,2-0.9,2-2l0,0v-6.1H4.9z M8.4,30.7     c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5C9.9,30,9.3,30.7,8.4,30.7C8.4,30.7,8.4,30.7,8.4,30.7z      M12.5,29.9c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8l0,0C13.2,29.6,12.9,29.9,12.5,29.9z M15,29.9     c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C15.8,29.6,15.4,29.9,15,29.9z M27.3,31.2h-0.8v-4.1h0.8V31.2     z M29.3,31.2h-0.8v-4.1h0.8V31.2z"
                    />
                    <polygon
                        className="cloud st3"
                        points="31.2,12 32,10.9 4.9,10.9 5.6,12 4.9,13.1 32,13.1    "
                    />
                    <polygon
                        className="cloud st3"
                        points="31.2,24 32,22.9 4.9,22.9 5.6,24 4.9,25.1 32,25.1    "
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const CloudSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        width="36.8px"
        height="30px"
        viewBox="0 0 36.8 36"
        enableBackground="new 0 0 36.8 36"
        xmlSpace="preserve"
    >
        <style type="text/css">
            {`
                .server.st0{fill:#243858;}
                .server.st1{opacity:0.5;fill:#243858;enable-background:new    ;}
                .server.st2{display:none;}
                .server.st3{display:inline;}
            `}
        </style>
        <g id="Layer_2_1_">
            <g id="Layer_2_2_">
                <g id="N700_1_">
                    <path
                        className="server st0"
                        d="M30.2,13.5c-0.6,0-1.2,0.1-1.7,0.3C27.4,8.2,22,4.6,16.5,5.7c-4.1,0.8-7.3,4-8.1,8.1     c-0.6-0.2-1.2-0.3-1.8-0.3c-3.5,0-6.3,2.8-6.3,6.3c0,3.5,2.8,6.3,6.3,6.3h1.2c0-0.2,0-0.3,0-0.5c0.1-2.9,2.6-5.1,5.5-5     c0.7,0,1.5,0.1,2.1,0.4c1-3,3.8-5,7-5c3.4-0.1,6.4,2.2,7.2,5.5h0.1c2,0,3.7,1.3,4.3,3.1c2.7-2.2,3-6.2,0.8-8.8     C33.7,14.3,32,13.5,30.2,13.5L30.2,13.5z"
                    />
                    <path
                        className="server st1"
                        d="M34.4,26c0-2.5-2-4.6-4.6-4.6h-0.1c-0.8-3.3-3.8-5.6-7.2-5.5c-3.2,0-6,2-7,5c-0.7-0.3-1.4-0.4-2.1-0.4     c-2.9-0.1-5.3,2.1-5.5,5s-2.6,5.1-5.5,5h27.4h0.3C32.5,30.4,34.4,28.4,34.4,26z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_1" className="server st2">
            <title>admin-server</title>
            <g id="Layer_2" className="server st3">
                <g id="N700">
                    <path
                        className="server st0"
                        d="M29.9,2.7H6.9c-1.1,0-2,0.9-2,2c0,0,0,0,0,0v6.1H32V4.8C32,3.7,31.1,2.7,29.9,2.7z M8.4,8.3     c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S9.3,8.3,8.4,8.3L8.4,8.3z M12.5,7.6     c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C13.2,7.2,12.9,7.6,12.5,7.6z M15,7.6     c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C15.8,7.2,15.4,7.6,15,7.6z M27.3,8.8h-0.8V4.8h0.8V8.8     z M29.3,8.8h-0.8V4.8h0.8V8.8z"
                    />
                    <path
                        className="server st0"
                        d="M4.9,13.1v9.8H32v-9.8H4.9z M8.4,19.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5     c0,0,0,0,0,0C9.9,18.8,9.3,19.5,8.4,19.5z M12.5,18.8c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8l0,0     C13.2,18.4,12.9,18.8,12.5,18.8z M15,18.8c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0     C15.8,18.4,15.4,18.8,15,18.8z M27.3,20h-0.8V16h0.8V20z M29.3,20h-0.8V16h0.8V20z"
                    />
                    <path
                        className="server st0"
                        d="M4.9,25.1v6.1c0,1.1,0.9,2,2,2c0,0,0,0,0,0h23.1c1.1,0,2-0.9,2-2l0,0v-6.1H4.9z M8.4,30.7     c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5C9.9,30,9.3,30.7,8.4,30.7C8.4,30.7,8.4,30.7,8.4,30.7z      M12.5,29.9c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8l0,0C13.2,29.6,12.9,29.9,12.5,29.9z M15,29.9     c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8l0,0C15.8,29.6,15.4,29.9,15,29.9z M27.3,31.2h-0.8v-4.1h0.8V31.2     z M29.3,31.2h-0.8v-4.1h0.8V31.2z"
                    />
                    <polygon
                        className="server st1"
                        points="31.2,12 32,10.9 4.9,10.9 5.6,12 4.9,13.1 32,13.1    "
                    />
                    <polygon
                        className="server st1"
                        points="31.2,24 32,22.9 4.9,22.9 5.6,24 4.9,25.1 32,25.1    "
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const PricingTabs = ({
    cloudComponent,
    dataCenterComponent,
    dataProductKey
}: PricingTabsProps) => {
    const intl = useIntl();

    const tabs: IndividualTabPropsCustom[] = [
        {
            id: "cloud",
            textLabel: intl.formatMessage({
                id: "PricingTabs.cloud",
                defaultMessage: "Cloud"
            }),
            component: cloudComponent,
            iconBefore: <CloudSvg />
        },
        {
            id: "data-center",
            textLabel: intl.formatMessage({
                id: "PricingTabs.data-center",
                defaultMessage: "Data Center"
            }),
            component: dataCenterComponent,
            iconBefore: <DataCenterSvg />
        }
    ];

    return (
        <div css={tabStyles}>
            <TabsCustom
                id="pricingtabs"
                label="pricing tabs"
                headerText=""
                bodyText=""
                className="pricing-tabs"
                tabs={tabs}
                dataProductKey={dataProductKey}
            />
        </div>
    );
};
